import { useMemo } from "react"
import { CounterType } from "../../automationObjects/Devices/CounterType"
import { useGetEnergyMetersQuery } from "../../services/energyMeters"
import { CounterMedium } from "../../automationObjects/Devices/CounterMedium";

interface useGetPortfolioEnergyMetersOutput {
    count: number,
    items: any[] | undefined,
    error: any,
    isLoading: boolean,
    isSuccess: boolean,
    countersFlat: any[] | undefined,
}

function useGetPortfolioEnergyMeters(medium?: CounterMedium | undefined): useGetPortfolioEnergyMetersOutput {

    const counterTypeFilter =  `CounterType=${CounterType.FeedIn},${CounterType.FeedOut}` + (medium !== undefined ?  `&CounterMedium=${medium}` : '');
    const queryParams = counterTypeFilter;
    const { data: counters, isLoading, error, isSuccess } = useGetEnergyMetersQuery(queryParams); 
    const buildingsAndCounters = useMemo(() =>
        counters?.map((ci) => {
            return {
                parent: ci.building,
                counters: ci.energyMeters
            }
        }).filter((x) => x.counters.length > 0), [counters]);


    return {
        count: buildingsAndCounters?.length ?? 0,
        items: buildingsAndCounters,
        error: error,
        isLoading: isLoading,
        isSuccess: isSuccess,
        countersFlat: buildingsAndCounters?.flatMap((bc) => bc.counters.map((c) =>c))
    }
}

export default useGetPortfolioEnergyMeters;
